import { render, staticRenderFns } from "./Brands.vue?vue&type=template&id=08e92d3e&scoped=true&"
import script from "./Brands.vue?vue&type=script&lang=js&"
export * from "./Brands.vue?vue&type=script&lang=js&"
import style0 from "./Brands.vue?vue&type=style&index=0&id=08e92d3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e92d3e",
  null
  
)

export default component.exports